import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';

import { TariffsFacade } from '@personal-area/global/accounts/services';
import { AlertModule } from '@personal-area/global/ui';
import { LoaderModule } from '@personal-area/global/http/ui';
import { AccountCardComponent } from './account-card/account-card.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { AccountTariffComponent } from './account-tariff/account-tariff.component';
import { AccountTariffsComponent } from './account-tariffs.component';

@NgModule({
  declarations: [
    AccountTariffsComponent,
    AccountTariffComponent,
    AccountCardComponent,
  ],
  exports: [AccountTariffsComponent, AccountTariffComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LoaderModule,
    AccountSettingsComponent,
    AlertModule,
    LetDirective,
  ],
  providers: [TariffsFacade],
})
export class AccountTariffsModule {}
